// extracted by mini-css-extract-plugin
export default {"content":"lab-category-delete_content__SzAUF","buttons":"lab-category-delete_buttons__VPN6d","button":"lab-category-delete_button__OLXJ9","alert":"lab-category-delete_alert__zBkeK"};